{
  "There were errors when trying to update: {{message}}": "Fel uppstod vid försök att ändra: {{message}}",
  "There were errors when trying to create: {{message}}": "Fel uppstod vid försök att skapa: {{message}}",
  "Type": "Typ",
  "Title": "Titel",
  "Teaser": "Teaser",
  "Space": "Space",
  "Content Owner": "Contentägare",
  "User visibility": "Synlighet",
  "HIDDEN": "Dold",
  "VISIBLE": "Synlig",
  "FEATURED": "Utvald",
  "StartTime": "Starttid",
  "EndTime": "Sluttid",
  "Address": "Plats",
  "Url": "Url",
  "Room": "Rum",
  "Capacity": "Antal platser",
  "SEMINAR": "Seminarium",
  "WEBINAR": "Webbinarium",
  "ARTICLE": "Artikel",
  "ONLINE_LEARNING": "On-demand-lärande",
  "E_LEARNING": "E-Learning",
  "LEARNING_PATH": "Lärandeväg",
  "items-from-another-space": "Galleriet innehåller artiklar från andra utrymmen, vänligen ta bort dem innan du ändrar i utrymmet: \n{{space}}",
  "remove-item-collection": "Är du säker på att du vill ta bort detta Lärande från galleriet?",
  "no-collection-items": "Inga läranden har lagts till i galleriet",
  "Edit Collection": "Redigera Galleri",
  "Category": "Kategori",
  "Select category": "Välj kategori",
  "Subject": "Ämne",
  "Please select a category": "Vänligen välj kategori",
  "Language": "Språk",
  "Save & exit": "Spara & gå tillbaka",
  "Create & exit": "Skapa & gå tillbaka",
  "{{type}} saved successfully": "{{type}} sparades",
  "{{type}} archived successfully": "{{type}} arkiverades",
  "{{type}} deleted successfully": "{{type}} togs bort",
  "Teaser text": "Teaser text",
  "Participants": "Deltagare",
  "Teams": "Team",
  "Variants": "Varianter",
  "Select a format": "Välj format",
  "Digital": "Digitalt",
  "Classroom": "Klassrum",
  "Blended": "Mixat",
  "Institution": "Institution",
  "Instructors": "Facilitatorer",
  "Level": "Nivå",
  "Select a Level": "Välj nivå",
  "Basic": "Grundläggande",
  "Intermediate": "Medel",
  "Advanced": "Avancerad",
  "Select a Language": "Välj språk",
  "Select a Subject": "Välj ämne",
  "Total Effort": "Tid",
  "Global mandatory training": "Global obligatorisk träning",
  "Compliance training credit": "Tid lagd på compliancekurser",
  "Approval required": "Aktivera godkännande",
  "Enroll button disabled": "Inaktivera BOKAknapp",
  "Application form required": "Aktivera ansökningsformulär",
  "Confirmation message": "Bekräftelsemeddelande",
  "Social features enabled": "Aktivera diskussioner",
  "Discussion section": "Diskussionssektion",
  "Discussion section not matching format /abc, /abc/1:bar": "Diskussionssektionen matchar inte formatet /abc, /abc/1:bar",
  "create-section": "Skapa sektionen {{path}}/general?\nProdukt sparas.",
  "section-invalid-format": "Sektionen matchar inte formatet /abc, /abc/1:bar",
  "Create and add section": "Skapa och lägg till sektion",
  "Discussions root section": "Huvudsektion i diskussioner",
  "Reflections enabled": "Aktivera reflektioner",
  "Reflections section": "Sektion för reflektioner",
  "Reflection section not matching format /abc, /abc/1:bar": "Sektion för reflektioner matchar inte formatet /abc, /abc/1:bar",
  "Use default": "Använd standard",
  "Reflections": "Reflektioner",
  "Teams enabled": "Aktivera team",
  "confirm-disable-team": "Är du säker på att du vill inaktivera teams?\nDetta tar bort inställningar för team och går inte att ändra.",
  "confirm-delete-learning-path": "Är du säker på att du vill ta bort inlärningsbanan?",
  "Save changes": "Spara ändringar",
  "Description": "Beskrivning",
  "Provider": "Partner",
  "Link ({{providerName}})": "Lägg till länk",
  "Does this Learning path use Learnifier?": "Använder denna partner Learnifier?",
  "Choose partner {{applicable}}": "Anslut partner {{applicable}}",
  "(if applicable)": "(om applicerbart)",
  "Select a Partner": "Välj Partner",
  "Choose provider": "Anslut provider",
  "Select a Provider": "Välj Provider",
  "Attach Learnifier": "Lägg till lärväg från Learnifier",
  "Unable to load resource with id {{id}}": "Det gick inte att hämta resurs med id {{id}}",
  "Create resource": "Skapa verktyg",
  "Create {{type}}": "Skapa {{type}}",
  "Edit {{type}}": "Redigera {{type}}",
  "Unable to load {{pageType}} with id {{id}}": "Det gick inte att ladda {{pageType}} med id {{id}}",
  "Metadata": "Metadata",
  "Builder": "Kursbyggare",
  "Total effort in minutes": "Total tid i minuter",
  "Calculated effort": "Beräknad tid",
  "If no linked video blocks have been used this calculation is accurate. For linked video blocks manually add the video duration.": "Om inga video-block har använts är denna beräkning korrekt. Lägg till varaktigheten för länkade videor manuellt.",
  "Unable to calculate": "Kunde inte beräkna",
  "linked-video": "{{count}} länkad video",
  "linked-video_plural": "{{count}} länkade videor",
  "Connected resources": "Inkluderade resurser",
  "Lead paragraph for the page": "Inledning på sidan",
  "Reading time": "Lästid",
  "Edit": "Redigera",
  "Stop editing": "Spara",
  "Are you sure you want to archive this {{pageType}}?": "Är du säker på att du vill arkivera denna {{pageType}}?",
  "Are you sure you want to delete this {{pageType}}?": "Är du säker på att du vill radera denna {{pageType}}? Detta är permanent och du kan inte ångra dig.",
  "mark-participants-attended": "Markera {{total}} deltagare som deltog?",
  "mark-participants-not-attended": "Markera {{total}} deltagare som ej deltog?",
  "participants-attendance-success": "Deltagarnas närvaro uppdaterad",
  "participants-attendance-attended-empty-info": "Utvalda deltagare har redan deltagit",
  "participants-attendance-not-attended-empty-info": "Utvalda deltagare deltar redan inte",
  "mark-attended": "Markera som deltog",
  "mark-didnt-attend": "Markera som inte deltog",
  "learners-selected": "{{count}} LÄRARE VALD",
  "learners-selected_plural": "{{count}} LÄRARE VALDA",
  "Caption": "Undertext",
  "Text": "Text",
  "Select a video": "Välj en video",
  "allowed-video-providers": "Endast video från YouTube, Ted, Creo/Avalon One, Vimeo och Microsoft",
  "superadmin-embed-video": "Superadmin: Använd valfri länk (se bara till att det är en inbäddad länk)",
  "Audio/Podcast": "Audio/Podcast",
  "Resource": "Verktyg",
  "Video": "Videofil",
  "Video link": "Videolänk",
  "Video caption for descriptive purposes": "Beskrivande text för video",
  "Image caption for descriptive purposes": "Beskrivande bildtext",
  "Add new": "Lägg till",
  "contact support": "kontakta support",
  "video-error": "Ett fel uppstod relaterat till videon. Vänligen ta bort detta block och försök ladda upp den igen. Om problemet återstår, vänligen <1>kontakta support</1>.",
  "Transcoding": "Omkodar",
  "view": "visning",
  "Image": "Bild",
  "time": "tid",
  "seat": "plats",
  "seat_plural": "platser",
  "left": "kvar",
  "Viewing time": "Visningstid",
  "no calculation needed": "ingen uträkning krävs",
  "no calculation possible": "omöjlig uträkning",
  "Select type": "Välj typ",
  "Upload Video": "Ladda upp video",
  "Select Video": "Välj video",
  "Teaser text is used for the learning card and the learning page header": "Teasertext används för lärkort och sidhuvud för lärsidan",
  "Link not valid": "Ogiltig länk",
  "No variant chosen": "No variant chosen",
  "Are you sure that you want to {{action}} this user?": "Är du säker på att du vill {{action}} denna användare?",
  "approve": "godkänna",
  "reject": "neka",
  "remove": "ta bort",
  "Reject": "Neka",
  "Remove": "Ta bort",
  "Something went wrong with this order. Contact system admin about it.": "Något gick snett med denna order. Vänligen kontakta systemadministratören.",
  "Add participants": "Lägg till deltagare",
  "Pick a session": "Välj tillfälle",
  "Select session": "Välj tillfälle",
  "Add session": "Lägg till tillfällen",
  "Sessions": "Tillfällen",
  "email-notification-message": "Deltagarna kommer att notifieras via e-post",
  "new-participants-added": "{{count}} ny deltagare tillagd i kursen",
  "new-participants-added_plural": "{{count}} nya deltagare tillagda i kursen",
  "email-could-not-be-added": "Följande e-post kunde inte läggas till i kursen:",
  "email-could-not-be-added_plural": "Följande e-post kunde inte läggas till i kursen:",
  "Participant list": "Deltagarlista",
  "total-participants": "Den här kursen har totalt {{count}} deltagare",
  "total-participants_plural": "Den här kursen har totalt {{count}} deltagare",
  "participants-not-approved": " varav {{count}} ännu ej godkända",
  "Not a participant in the course": "Ej deltagare i kursen",
  "Team setup": "Team inställningar",
  "setup-info": "Baseras på antal tillgängliga deltagare och tar en bra spridning baserat på användares realm.",
  "setup-info2": "Team-storleken du väljer låses tills du inaktiverar teams och startar om igen.",
  "Pick teamsize:": "Välj teamstorlek:",
  "Old participants": "Gamla deltagare",
  "member-not-participating": "{{count}} team-medlem deltar inte i kursen.",
  "member-not-participating_plural": "{{count}} team-medlemmar deltar inte i kursen.",
  "remove-member": "Ta bort medlem",
  "remove-member_plural": "Ta bort medlemmar",
  "New participants": "Nya deltagare",
  "participants-without-team": "{{count}} deltagare utan team.",
  "participants-without-team_plural": "{{count}} deltagare utan team.",
  "Remove members not participating first.": "Ta bort medlemmar som inte deltar först.",
  "add-member": "Lägg till medlem i team",
  "add-member_plural": "Lägg till medlemmar i team",
  "Too many team members": "För många medlemmar",
  "Free spot": "Ledig plats",
  "Go to module {{moduleId}}": "Gå till modul {{moduleId}}",
  "Go to page {{pageId}}": "Gå till sida {{pageId}}",
  "A visible collection makes all learning items within it visible, regardless of the individual item user setting.": "Ett synligt galleri gör dess läranden synliga oavsett individuella användarinställningar.",
  "Add learnings": "Lägg till lärobjekt",
  "Learnings will be saved automatically when added or removed.": "Lärobjekt sparas automatiskt när de läggs till eller tas bort.",
  "location-enroll-error": "Ett fel inträffade",
  "Add learnings ({{count}} available)": "Lägg till lärobjekt ({{count}} tillgängliga)",
  "Connected people": "Delaktiga personer",
  "Leave empty to have infinite seats": "Lämna tomt för obegränsade platser",
  "Select a space": "Välj ett Space",
  "Use custom button text": "Skapa ny knapptext",
  "Custom button text": "Ny knapptext",
  "Button preview": "Förhandsvisa knapp",
  "Archive": "Arkivera",
  "Restore learning": "Återställ lärande",
  "This learning has been archived.": "Detta lärande har arkiverats.",
  "event-has-been_archived": "Detta event har arkiverats.",
  "event-has-been_ended": "Detta event är slut.",
  "Ended": "Slut",
  "Too many enrollments {{count}} available": "För många inskrivningar. Antal tillgängliga platser: {{count}}",
  "Enter e-mail addresses": "Skriv e-postadresser",
  "One e-mail address per row": "En e-postadress per rad",
  "Add": "Lägg",
  "email": "e-postadress",
  "emails": "e-postadresser",
  "participant": "deltagare",
  "participants": "deltagare",
  "Content": "Content",
  "Attributes": "Attribut",
  "Filter attributes...": "Filtrera attribut...",
  "More information": "Mer information",
  "Event information": "Eventinformation",
  "Additional connected people": "Ytterligare delaktiga personer",
  "Subject Matter Expert": "Ämnesexpert",
  "Moderator": "Moderator",
  "Learning facilitator": "Facilitator",
  "Role Responsible": "Rollansvarig",
  "Subject Owner": "Ämnesägare",
  "Select a role": "Välj en roll",
  "A person can only have one role": "En person kan bara ha en roll",
  "Upload an exported HTML5 E-Learning bundle": "Ladda upp e-learningpaket",
  "No unsaved changes.": "Inga ändringar som inte sparats.",
  "Changes have not been saved.": "Ändringar har inte sparats.",
  "You have unsaved changes.\n Are you sure that you want to leave?": "Du har ändringar som inte sparats.\n Är du säker på att du vill lämna sidan?",
  "Missing required field(s).": "Det saknas obligatoriska fält.",
  "missing-required-field": "Det saknas ett obligatoriskt fält: {{item}}.",
  "missing-required-field_plural": "Det saknas $t({{count}}, {\"count\": {{count}}, \"ns\": \"common\", \"context\": \"neutrum\" }) obligatoriska fält: {{item}}.",
  "Add block": "Lägg till block",
  "You have an empty block added.": "Du har ett tomt block.",
  "Link URL": "Länk",
  "Link text": "Länktext",
  "max-participant-batch": "Du kan endast lägga till {{max}} deltagare åt gången.",
  "Last edited by": "Senast redigerad av",
  "Created by": "Skapad av",
  "completion-status-has-been-set": "Slutförandestatus har ställts in",
  "attended": "Deltog",
  "didn't-attend": "Deltog inte",
  "learnings-reset-space": "Listan med tillagda lärobjekt har rensats eftersom utrymmet har ändrats",
  "Participant email": "Epost deltagare",
  "Send invite": "Skicka inbjudan",
  "Add group": "Lägg till grupp",
  "Add emails information": "Lägg till en eller flera e-postadresser. En adress per rad.",
  "Enrolled": "Anmäld",
  "Attended": "Deltog",
  "In waitlist": "På väntelista",
  "Did not attend": "Deltog inte",
  "Waiting list": "Väntelista",
  "waitlist-disable-clear-waitlisted-users-message": "Inaktivering av väntelistan kommer ta bort alla väntlistade användare från det här eventet",
  "imparta-invalid-object-id": "Unrecognized Imparta course URL. Expected links like \"https://iportal-integration.azurewebsites.net/Home/Resources?CourseProgramme=23469\" \n\nYou can continue, but no learning progress will be captured for this learning path",
  "pluralsight-invalid-object-id": "Unrecognized Pluralsight course URL. Expected links like \"https://app.pluralsight.com/library/courses/8ae31d47-b224-405a-ad2f-e6de581ceab9\" \n\nYou can continue, but no learning progress will be captured for this learning path.",
  "object-urn": "Object URN (endast superadmins)"
}
